import { Response } from "@angular/http";
import { ChangeQItem } from "./item";
import { HTTP_METHODS } from "./index";
import { IOperationResult } from "./operation-result.interface";

export class OperationResult implements IOperationResult {

    constructor(public item: ChangeQItem, public response: Response) {
        // no opp
    }

    succeeded(): boolean {

        switch (this.item.method) {
            case HTTP_METHODS.POST:
                return this.response.status === 201;
            case HTTP_METHODS.PATCH:
                return this.response.status === 204;
            case HTTP_METHODS.DELETE:
                return this.response.status === 204;
            case "REFRESH":
                return this.response.status === 200;
            default:
                throw Error(`unknown method ${this.item.method}`);
        }
    }

    setPrimaryResult(result: IOperationResult): IOperationResult {
        return undefined;
    }

    addSubResourceResult(result: IOperationResult): IOperationResult {
        return undefined;
    }

    getPrimaryResult(): IOperationResult {
        return this;
    }

    getSubResourceResults(): Array<IOperationResult> {
        return [];
    }
}



// WEBPACK FOOTER //
// ./src/core/services/sync-up/operation-result.ts